import type { LiveMatch } from '@/models/liveMatch';
import { formatFixtureDisplayLabel } from '@/helpers';
import { formatLiveMetaLine, formatLiveStatusBadge } from '@/helpers/fixtures/liveMatchDisplay';
import { formatRegulationScoreLine, resolvePenaltyScore } from '@/helpers/fixtures/matchScoreDisplay';
import { MatchScoreAccordionRow } from './matchRows/MatchScoreAccordionRow';

export function LiveMatchRow(props: {
  liveMatch: LiveMatch;
  svg?: boolean;
  bracketLabel?: string;
  showBracketLabel?: boolean;
}) {
  const { liveMatch } = props;

  return (
    <MatchScoreAccordionRow
      homeTeam={liveMatch.homeTeam}
      awayTeam={liveMatch.awayTeam}
      goalsScoreLine={formatRegulationScoreLine(liveMatch.goalsHome, liveMatch.goalsAway)}
      penaltyScore={resolvePenaltyScore(liveMatch.goalsHome, liveMatch.goalsAway, {
        wentToPens: liveMatch.wentToPens,
        penaltiesHome: liveMatch.penaltiesHome,
        penaltiesAway: liveMatch.penaltiesAway,
      })}
      metaLine={formatLiveMetaLine(liveMatch.cityName, liveMatch.ukBroadcaster)}
      events={liveMatch.events}
      variant='live'
      statusBadge={formatLiveStatusBadge(liveMatch)}
      bracketLabel={props.bracketLabel}
      showBracketLabel={props.showBracketLabel}
      svg={props.svg}
    />
  );
}

export function liveMatchBracketLabel(liveMatch: LiveMatch): string | undefined {
  const raw = liveMatch.bracketLabel ?? liveMatch.matchId;
  return raw ? formatFixtureDisplayLabel(raw) : undefined;
}
